export enum SelectType {
  LIST_DROP = 0,
  LIST_NO_DROP = 1,
  LIST_CARD = 2
}
